const CategoryCell = ({ category }) => (
    <span className="badge badge-light">{category.name}</span>
)

export default CategoryCell